import React, { useEffect, useRef, useState } from "react";
import { subscribeFeedback } from "../../services/feedbackBus";
import { playFeedbackTone } from "../../utils/feedbackAudio";

function stageStyle(stage) {
  if (stage === "pressed") return { bg: "rgba(212,175,55,0.18)", border: "rgba(212,175,55,0.35)", color: "#fff" };
  if (stage === "local") return { bg: "rgba(74,222,128,0.18)", border: "rgba(74,222,128,0.35)", color: "#fff" };
  if (stage === "db") return { bg: "rgba(212,175,55,0.26)", border: "rgba(212,175,55,0.42)", color: "#fff" };
  return { bg: "rgba(231,76,60,0.28)", border: "rgba(231,76,60,0.52)", color: "#fff" };
}

export default function FeedbackLayer() {
  const [toast, setToast] = useState(null);
  const clearTimerRef = useRef(null);

  useEffect(() => {
    const unsub = subscribeFeedback((p) => {
      setToast({
        id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
        stage: p.stage,
        actionId: p.actionId,
        label: p.label,
        message: p.message,
      });

      if (clearTimerRef.current) clearTimeout(clearTimerRef.current);
      clearTimerRef.current = setTimeout(() => setToast(null), 1600);

      // Audio is short; keep it best-effort.
      playFeedbackTone(p.stage).catch?.(() => {});
    });
    return unsub;
  }, []);

  if (!toast) return null;

  const s = stageStyle(toast.stage);
  const text = toast.stage === "error"
    ? `✗ ${toast.message || "Error"}`
    : `${toast.stage === "pressed" ? "•" : "✓"} ${toast.label || "Acción"}`;

  return (
    <div
      aria-live="polite"
      style={{
        position: "fixed",
        top: 14,
        left: 0,
        right: 0,
        display: "flex",
        justifyContent: "center",
        zIndex: 20000,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          pointerEvents: "none",
          padding: "10px 14px",
          borderRadius: 999,
          background: s.bg,
          border: `1px solid ${s.border}`,
          color: s.color,
          fontSize: "0.85rem",
          backdropFilter: "blur(10px)",
          boxShadow: "0 18px 50px rgba(0,0,0,0.5)",
          transform: "translateZ(0)",
          transition: "opacity 0.18s ease",
          maxWidth: "92vw",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {text}
      </div>
    </div>
  );
}

